var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropUp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.52,
    height: 8.874,
    viewBox: "0 0 15.52 8.874",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M13.95,13.922l5.868,5.873a1.1,1.1,0,0,0,1.566,0,1.118,1.118,0,0,0,0-1.571L14.736,11.57a1.107,1.107,0,0,0-1.529-.032l-6.7,6.682A1.109,1.109,0,1,0,8.077,19.79Z",
    transform: "translate(-6.188 -11.246)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropUp);
export default __webpack_public_path__ + "static/media/drop_up.ef84374e0d97f8923f2241a9ac0ea82d.svg";
export { ForwardRef as ReactComponent };